<div class="close-btn" (click)="onConfirmClick()">
    <img src="../../../../assets/images/smallclose.svg" />
</div>
<mat-dialog-content>
    <div class="document-icon-container"><img mat-card-image class="document-icon"
            src="../../../../assets/images/document-icon.svg" alt="Photo"></div>
    <div class="bil-font-regular document-label">
        The certificate of commencement of business Is mandatory for public companies with share capital
    </div>
</mat-dialog-content>